import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import Collapsible from 'react-collapsible';
import NameFormat from '../../nameFormat/NameFormat';
import Surname from '../../surname/Surname';
import GivenName from '../../quotationPVComponent/givenName/GivenName';
import MaritalStatus from '../../maritalStatus/MaritalStatus';
import Sex from '../../sex/Sex';
import AgeRange from '../../quotationPVComponent/ageRange/AgeRange';
import DrivingExperience from '../../drivingExperience/DrivingExperience';
import NoOfClaimsInPast3Years from '../../noOfClaimsInPast3Years/NoOfClaimsInPast3Years';
import TotalClaimAmountInPast3Years from '../../totalClaimAmountInPast3Years/TotalClaimAmountInPast3Years';
import Occupation from '../occupation/Occupation';
import Nationality from '../../quotationPVComponent/nationality/Nationality';
import RelationshipWithPolicyholder from '../../relationshipWithPolicyholder/RelationshipWithPolicyholder';

class ParticularOfAdditionalDriver extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      nameFormatRequired: false,
      surnameRequired: false,
      drivingExperienceRequired: true,
      noOfClaimsRequired: true,
      totalClaimAmountRequired: true,
      sexRequired: true
    }
    this.handleChangeParticularOfAdditionalDriver = this.props.handleChangeParticularOfAdditionalDriver.bind(this, this.props.particularOfAdditionalDriver.itemId)
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">
          <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ open: !this.state.open })}>
            {this.state.open ? `${this.props.title} ▲ ` : `${this.props.title} ▼ `}
          </a>
        </h3>
        <Collapsible open={this.state.open}>
          <FormGroup controlId="nameFormat">
            <Col sm={6}>
              <NameFormat
                nameFormat={this.props.particularOfAdditionalDriver.nameFormat}
                handleChangeNameFormat={this.handleChangeParticularOfAdditionalDriver}
                required={this.state.nameFormatRequired}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="surnameGivenName">
            <Col sm={6}>
              <Surname
                surname={this.props.particularOfAdditionalDriver.surname}
                handleChangeSurname={this.handleChangeParticularOfAdditionalDriver}
                required={this.state.surnameRequired}
              />
            </Col>
            <Col sm={6}>
              <GivenName
                givenName={this.props.particularOfAdditionalDriver.givenName}
                handleChangeGivenName={this.handleChangeParticularOfAdditionalDriver}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="drivingExperienceAgeRange">
            <Col sm={6}>
              <DrivingExperience
                drivingExperience={this.props.particularOfAdditionalDriver.drivingExperience}
                handleChangeDrivingExperience={this.handleChangeParticularOfAdditionalDriver}
                required={this.state.drivingExperienceRequired}
                validation={this.props.validation}
              />
            </Col>
            <Col sm={6}>
              <AgeRange
                ageRange={this.props.particularOfAdditionalDriver.ageRange}
                handleChangeAgeRange={this.handleChangeParticularOfAdditionalDriver}
                calculation={this.props.calculation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="maritalStatusSex">
            <Col sm={6}>
              <MaritalStatus
                maritalStatus={this.props.particularOfAdditionalDriver.maritalStatus}
                handleChangeMaritalStatus={this.handleChangeParticularOfAdditionalDriver}
                disabled={false}
              />
            </Col>
            <Col sm={6}>
              <Sex
                sex={this.props.particularOfAdditionalDriver.sex}
                handleChangeSex={this.handleChangeParticularOfAdditionalDriver}
                required={this.state.sexRequired}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="noOfClaimInPast3YearTotalClaimAmountInPast3Years">
            <Col sm={6}>
              <NoOfClaimsInPast3Years
                noOfClaimsInPast3Years={this.props.particularOfAdditionalDriver.noOfClaimsInPast3Years}
                handleChangeNoOfClaimsInPast3Years={this.handleChangeParticularOfAdditionalDriver}
                required={this.state.noOfClaimsRequired}
                validation={this.props.validation}
              />
            </Col>
            <Col sm={6}>
              <TotalClaimAmountInPast3Years
                totalClaimAmountInPast3Years={this.props.particularOfAdditionalDriver.totalClaimAmountInPast3Years}
                handleChangeTotalClaimAmountInPast3Years={this.handleChangeParticularOfAdditionalDriver}
                required={this.state.totalClaimAmountRequired}
                disabled={false}
                validation={this.props.validation}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="relationshipWithPolicyholderNationality">
            <Col sm={6}>
              <RelationshipWithPolicyholder
                relationshipWithPolicyholder={this.props.particularOfAdditionalDriver.relationshipWithPolicyholder}
                handleChangeRelationshipWithPolicyholder={this.handleChangeParticularOfAdditionalDriver}
              />
            </Col>
            <Col sm={6}>
              <Nationality
                nationality={this.props.particularOfAdditionalDriver.nationality}
                handleChangeNationality={this.handleChangeParticularOfAdditionalDriver}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="occupation">
            <Col sm={6}>
              <Occupation
                occupation={this.props.particularOfAdditionalDriver.occupation}
                handleChangeOccupation={this.handleChangeParticularOfAdditionalDriver}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          </Collapsible>
      </div>
    )
  }
}

ParticularOfAdditionalDriver.propTypes = {
  title: PropTypes.string,
  particularOfAdditionalDriver: PropTypes.object,
  handleChangeParticularOfAdditionalDriver: PropTypes.func,
  calculation: PropTypes.func,
  validation: PropTypes.func
};

export default ParticularOfAdditionalDriver;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/particularOfAdditionalDriver/ParticularOfAdditionalDriver.js